(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const mainImage = gallery.querySelector('.medixo-product-gallery__main img');
    const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');
    const zoomTrigger = gallery.querySelector('[data-gallery-zoom]');
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
    const closeButton = gallery.querySelector('[data-gallery-close]');

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumbnail.dataset.fullImage;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumbnail.dataset.imageAlt || '';
        thumbnails.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');
      });
    });

    if (zoomTrigger && dialog && dialogImage) {
      zoomTrigger.addEventListener('click', () => {
        if (!mainImage) return;
        dialogImage.src = mainImage.currentSrc || mainImage.src;
        dialogImage.alt = mainImage.alt;
        dialog.showModal();
      });
    }

    if (closeButton && dialog) {
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
